import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { productsUtcOffsetActions } from '../../slices/productsUtcOffsetSlice'
import { getUrlWithVersion } from '../../../api/api'

export const fetchUtcOffset = createAsyncThunk<
    void,
    { productId: string },
    ThunkConfig<string>
>('productsUtcOffsetSlice/fetchUtcOffset', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { productId } = args

    try {
        const { data: offset } = await api.get<number>(
            getUrlWithVersion(`/products/${productId}/utc_offset`)
        )

        if (typeof offset !== 'number') {
            const error = new Error('Received utc offset in wrong format')
            console.error(error.message)
            return
        }

        dispatch(
            productsUtcOffsetActions.setProductUtcOffset({
                guid: productId,
                data: offset,
            })
        )
    } catch (e) {
        console.error(e)
        return rejectWithValue('Failed to fetch product utc offset')
    }
})
